"use client"

import { useCustomSearchParams } from "@/hooks/use-search-params"
import { BaseCloseButton } from "../base-close-button"

const QuestionarioHeaderCloseButton = () => {
  const [, setSearchParams] = useCustomSearchParams()

  /*--------------------helpers--------------------*/

  const handleClick = () => {
    setSearchParams((prevParams) => {
      prevParams.set("confirm", "open")
      prevParams.set("leave", "true")
      return prevParams
    })
  }

  return <BaseCloseButton onClick={handleClick} />
}

export { QuestionarioHeaderCloseButton }
